<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
        icon="mdi-text-short"
        icon-action="mdi-pencil-outline"
        title="Código da loja"
        :subtitle="getSubtitle()"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Código da empresa
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>


      <v-card-text>
        O código da loja é um identificador exclusivo para cada empresa da sua
        conta. Qualquer pessoa que gerencia um local no Google pode ver o
        próprio código da loja.
      </v-card-text>

      <v-card-text>
        <v-form ref="form" v-model="formValid" lazy-validation @submit="e => e.preventDefault()">
          <v-text-field
            v-model="formData.store_code"
            :rules="codeRules"
            required
            outlined
            v-on:keyup.enter="() => callAction()"
          ></v-text-field>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn :loading="loading" color="primary" text @click="callAction">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem';
import { mapState } from 'vuex';
import _ from 'lodash';
import { TYPE_UPDATE_LOCATION_STORE_CODE } from '@/constants/tasks';
import ScheduleForm from '@/views/Locations/Components/ScheduleForm';

export default {
  name: 'LocationCodeModal',
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: {
      type: Array
    }
  },
  components: {
    LocationInfoItem,
    ScheduleForm
  },
  methods: {
    getSubtitle() {
      if (this.location && this.location.data) {
        return this.location.data.store_code
      }
      return this.formData.store_code
    },
    cancel: function() {
      this.open = false;
      this.resetData();
    },
    callAction: async function() {
      if (!this.validate()) {
        return
      }

      if (this.bulkUpdate) {
        this.$emit('savePayload', 'store_code', this.formData.store_code);
      } else if (this.action) {
        this.loading = true;
        await this.action(this.formData);
        this.loading = false;
      }
      this.open = false;
    },
    validate: function() {
      return this.$refs.form.validate();
    },
    changeScheduleDate: function(data) {
      this.formData.schedule_start = data.schedule_start;
      this.formData.schedule_start_at = data.schedule_start_at;
      this.formData.schedule_end = data.schedule_end;
      this.formData.schedule_end_at = data.schedule_end_at;
    },
    resetData: function() {
      const { store_code } = this.formDataOriginal;
      this.formData.store_code = store_code;
    }
  },
  computed: {
    ...mapState({
      location: (state) => state.locations.location
    })
  },
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_STORE_CODE) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_STORE_CODE,
      store_code: '',
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: ''
    },
    codeRules: [(v) => !!v || 'O código da empresa é obrigatório'],
    alertScheduledTask: null,
  }),
  beforeDestroy() {
    this.resetData();
  },
  watch: {
    location: function(location) {
      if (!this.bulkUpdate) {
        this.formData.store_code = _.get(location, 'data.store_code');
        this.formDataOriginal.store_code = _.get(location, 'data.store_code');
      }
    },
    open: function(open) {
      if (open && !this.bulkUpdate) {
        this.formData.store_code = _.get(this.location, 'data.store_code');
        this.formDataOriginal.store_code = _.get(
          this.location,
          'data.store_code'
        );
      }
    }
  }
};
</script>

<style scoped></style>
